import { Instance, types } from "mobx-state-tree";
import { withSetPropAction } from "./helpers/withSetPropAction";
import {
  ServiceItem,
  CheckTypeEnum,
  EnableStatus,
} from "@/components/product/interface";
import { ITEM_TYPE } from "@/components/product/const";

// ServiceItem 模型定义
const ServiceItemModel = types.model("ServiceItem", {
  name: types.string,
  skuId: types.string,
  landedPriceText: types.string,
  crossPriceText: types.maybeNull(types.string),
  checkType: types.enumeration("CheckType", Object.values(CheckTypeEnum)),
  detailUrl: types.string,
  statusText: types.maybeNull(types.string),
  uuid: types.maybeNull(types.string),
  enable: types.enumeration("EnableStatus", Object.values(EnableStatus)),
});

export const ServiceListStoreModel = types
  .model("ServiceListStore")
  .props({
    mainSkuId: types.string,
    selectedListAll: types.map(types.array(ServiceItemModel)),
  })
  .actions(withSetPropAction)
  .views((self) => ({
    // selectedList 作为计算属性，自动根据当前 mainSkuId 获取对应的选中项
    get selectedList() {
      return self.selectedListAll.get(self.mainSkuId) || [];
    },
  }))
  .actions((self) => ({
    // 组合方法：同时设置 mainSkuId 和对应的 selectedList
    setMainSkuIdAndSelectedList(
      mainSkuId: string,
      selectedList: ServiceItem[],
    ) {
      self.mainSkuId = mainSkuId;
      self.selectedListAll.set(mainSkuId, selectedList);
    },

    // 获取服务品选中态参数
    getServiceParam() {
      // @ts-ignore
      const addonProducts = self.selectedList?.map((item: ServiceItem) => {
        return {
          num: 1,
          skuId: item?.skuId,
          itemType: ITEM_TYPE.BigItem,
        };
      });
      return { addonProducts };
    },
  }));

export interface ServiceListStoreModel
  extends Instance<typeof ServiceListStoreModel> {}

// // 创建 store 实例的工厂函数
// export const createServiceListStore = () => {
//   return ServiceListStoreModel.create({
//     selectedList: [],
//   });
// };
